/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_NofollowInputs */

const en_directory_submit_review_nofollow = /** @type {(inputs: Directory_Submit_Review_NofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nofollow (no badge)`)
};

const zh_directory_submit_review_nofollow = /** @type {(inputs: Directory_Submit_Review_NofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nofollow（无徽章）`)
};

/**
* | output |
* | --- |
* | "Nofollow (no badge)" |
*
* @param {Directory_Submit_Review_NofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_nofollow = /** @type {((inputs?: Directory_Submit_Review_NofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_NofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_nofollow(inputs)
	return zh_directory_submit_review_nofollow(inputs)
});
export { directory_submit_review_nofollow as "directory.submit.review.nofollow" }